<template>
  <div>
    <header class="header">
      <div class="header__inner type_02">
        <div class="header__btns">
          <button class="header__btns prev" @click="close"></button>
        </div>
        <h1 class="header__ttl">{{ data.title }}</h1>
        <div class="header__btns"></div>
      </div>
    </header>
    <!--main-->
    <main class="main" role="main">
      <div class="main__inner"><!-- 배경: bg-->
        <div class="main__con">
          <div class="sign__page">
            <div class="txt__inner">
              <p>목숨이 긴지라 천하를 소리다.이것은 듣기만 몸이 인도하겠다는 보는 반짝이는 것이다. 우리 커다란 예가 있으며, 용감하고 것이다. 싸인 더운지라 얼음과 몸이 끓는 그림자는 속에 것이다. 품에 청춘 과실이 심장의 봄바람이다. 설레는 심장의 내는 때에, 열락의 풀이 사람은 힘있다. 열락의 방지하는 가지에 공자는 많이 인생의 듣는다. 고동을 바로 우리의 눈이 그들에게 보이는 것이 창공에 말이다. 위하여, 무엇이 주며, 사막이다. 위하여서 그들에게 원대하고, 청춘의 않는 그들에게 불러 약동하다. 위하여 청춘이 이상 가지에 것이다.</p>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>
<script>
export default {
  name: 'terms-modal',
  props: {
    data: {
      type: [Array, Object],
      description: '약관 데이터',
      default: () => {
      }
    },
    callBack: {
      type: [Function]
    }
  },
  data: function () {
    return {
      isShow: false,
      params: {
        termsType: this.$ConstCode.TERMS_TYPE.TERMS
      },
      termsNo: 0,
      termsDescription: '',
      termsList: []
    }
  },
  watch: {
    'termsNo': function (val) {
      let termsDescription = ''
      this.termsList.forEach(item => {
        if (item.termsNo === val) {
          termsDescription = item.termsDescription
        }
      })
      this.termsDescription = termsDescription
    }
  },
  created: function () {
    // this.getTermsList()
  },
  methods: {
    getTermsList: function () {
      this.$AccountSvc.getTermsList(this.params)
        .then(res => {
          const code = res.code
          const message = res.message
          const entity = res.entity

          console.log('code: %d\nmessage: %s\nentity: %o\nstringify: \n%s', code, message, entity, JSON.stringify(entity))
          if (code === 1) {
            this.isShow = true
            this.termsList = entity

            if (!this.$Util.isEmpty(this.termsList)) {
              this.termsNo = this.termsList[0].termsNo
            }
          } else {
            this.$Util.modalAlert({message: message})
          }
        })
    },
    close: function () {
      this.$emit('eventClose')
    }
  }
}
</script>

<style scoped>
/*.modalPage {*/
/*  position: fixed;*/
/*  transition-property: top;*/
/*  transition-duration: 0.5s;*/
/*  transition-delay: 0s;*/
/*  top: 100vh;*/
/*  width: 100%;*/
/*  height: 100%;*/
/*  z-index: 100;*/
/*}*/

/*.modalPage.on {*/
/*  transition-property: top;*/
/*  transition-duration: 0.5s;*/
/*  transition-delay: 0s;*/
/*  top: 0;*/
/*}*/
</style>
